<template>
  <v-layout id="login" align-center justify-center>
    <v-flex xs12 md6 @keydown.enter="login()">
      <v-layout row align-center justify-center>
        <v-flex xs12 md10 lg8>
          <img class="logo" src="/static/images/logo.png">
          <v-toolbar-title class="toolbar-title">Entrar</v-toolbar-title>
          <v-card-text>
            <v-form>
              <v-text-field prepend-icon="fal fa-user" v-model="form.email"
                label="E-mail" type="text"></v-text-field>
              <v-text-field prepend-icon="fal fa-lock" v-model="form.password"
                label="Senha" :append-icon="hidePassword ? 'fal fa-eye-slash' : 'fal fa-eye'"
                @click:append="() => (hidePassword = !hidePassword)"
                :type="hidePassword ? 'password' : 'text'"></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <router-link class="simple-gray-link" :to="{ name: 'LoginForgot'}">
              Esqueceu a senha?
            </router-link>
            <v-spacer></v-spacer>
            <v-btn @click.stop="login()" round large depressed color="success"
              :loading="loadingLogin">
              Entrar
            </v-btn>
          </v-card-actions>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex xs12 md6 fill-height class="login-image" hidden-sm-and-down></v-flex>
  </v-layout>
</template>

<script>
// eslint-disable-next-line
import router from '@/router'
import axios from 'axios'
import EventBus from '@/event-bus'
import { Auth } from 'aws-amplify'

export default {
  name: 'Login',
  data: () => ({
    drawer: null,
    hidePassword: true,
    loadingLogin: false,
    form: {
      email: '',
      password: ''
    }
  }),

  methods: {
    connect (token, id) {
      axios.defaults.headers.common['Authorization'] = `${token}`

      // eslint-disable-next-line
      axios.get(`${API.users}/${id}`).then(response => {
        if (!response.data.user) { response.data.user = {} }
        response.data.user.logged = true
        response.data.user.token = `${token}`
        this.loadingLogin = false
        localStorage.setItem('currentUser', JSON.stringify(response.data.user))
        localStorage.setItem('currentToken', token)
        window.location.reload()
      }).catch(errors => {
        this.loadingLogin = false
        EventBus.$emit('showSnackbar', {
          message: 'Usuário ou senha inválidos',
          color: 'error'
        })
      })
    },

    login () {
      this.loadingLogin = true
      Auth.signIn(this.form.email, this.form.password)
        .then(user => {
          let session = Auth.currentSession()
          session.then(CognitoUserSession => {
            if (CognitoUserSession.idToken.jwtToken) {
              this.connect(CognitoUserSession.idToken.jwtToken, CognitoUserSession.idToken.payload['sub'])
            }
          })
        })
        .catch(() => {
          this.loadingLogin = false
          EventBus.$emit('showSnackbar', {
            message: 'Usuário ou senha inválidos',
            color: 'error'
          })
        })
    }
  }
}
</script>

<style src="../assets/scss/components/login.scss" lang="scss"></style>



// WEBPACK FOOTER //
// src/components/Login.vue